import {cookie} from "../lib/cookie";
import {writable} from 'svelte/store';

let userObject = {
    id: null,
    name: null,
    email: null,
    token: null,
};

const {get, set, update, subscribe} = writable(userObject);

const user = {
    set,
    update,
    subscribe,

    token: () => {
        return userObject.token || '';
    },

    acronym : () => {
        if (!userObject.name) {
            return '';
        }
        return userObject.name.split(' ').map(function(item){return item[0]}).join('');
    },

    initialize: () => {
        user.update(obj => {
            let coo = JSON.parse(cookie.get('sourceman') || "{}");
            obj.token = coo.token;
            return obj;
        });
    },

    setUser: data => {
        user.update(obj => {
            obj.id = data.id;
            obj.name = data.name;
            obj.email = data.email;
            obj.token = data.token;
            user.saveCookie();
            return obj;
        });
    },

    setToken: (token) => {
        user.update(obj => {
            obj.token = token;
            user.saveCookie();
            return obj;
        });
    },

    clearToken: () => {
        user.update(obj => {
            obj.token = null;
            user.saveCookie();
            return obj;
        });
    },

    saveCookie: () => {
        let coo = {
            token: userObject.token,
        };
        cookie.create('sourceman', JSON.stringify(coo));
    },
}

export default user;